/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Inactive/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Inactive({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/PracticeHubAccountStatus/Inactive"
  
}) {
let constantData = 'Needs to activate account'
let patientPersonPublicUserAccountEmailValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person.public_user.account.email',
})
let aggregateData = fromAggregate.join(constantData, patientPersonPublicUserAccountEmailValueData)
let dtColorsOrange800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.800'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsOrange800}
 data="'Needs to activate account'"
 data="patient.person.public_user.account.email"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}